import axios from "axios";
import LocalStorage from "../helper/LocalStorage";

const URL = process.env.REACT_APP_API_URL;

// Used to store the in-flight refresh promise
let refreshInProgress = null;

const refreshTokenConfig = (refreshtoken, token) => ({
  method: "post",
  url: `${URL}/api/v1/identity/sso/tokens/refresh`,
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
  data: {
    grant_type: "refresh_token",
    refresh_token: refreshtoken,
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
  },
});

export const refreshToken = (refreshtoken, token) => {
  if (refreshInProgress) {
    return refreshInProgress;
  }
  refreshInProgress = axios(refreshTokenConfig(refreshtoken, token))
    .then((response) => {
      const newToken = response.data.access_token || response.data.token;
      LocalStorage.setAuthenticationToken(newToken);
      LocalStorage.setRefreshToken(response.data.refresh_token);
      return response;
    })
    .catch((error) => {
      throw error;
    })
    .finally(() => {
      refreshInProgress = null;
    });
  return refreshInProgress;
};
